import React, { useCallback } from 'react'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'

import { MessageErrorInput } from 'Components/Message/Error/input'

import ArrowIcon from 'Assets/Images/icons/arrow'
import { globalSort } from '../../../shared/libraries/sort'
import { useFormChildLogic } from '../index'

export const SelectDashboardUnstyled = props => {
  const options = getSelectOptions({
    options: props.options,
    sorted: props.sorted,
    ASC: props.ASC,
  })

  var input = props.input || {
    value: props.value,
    name: props.name,
    disabled: props.disabled,
    ...props.input,
  }

  // Some old components are still using "validate" prop
  const validator = props.validator || props.validate

  const { updateForm, value, error } = useFormChildLogic({
    name: props.name,
    validator,
    initValue: props.initValue,
  })

  const handleChange = useCallback(
    (...args) => {
      const value = args[2]

      if (props.onChange) {
        props.onChange(...args)
      }

      if (input.onChange) {
        input.onChange(value)
      }

      props.onChangeCb && props.onChangeCb(value, args[1])

      updateForm(value)
    },
    [validator],
  )

  return (
    <div className="select-wrapper" id={props.id}>
      <div className={`${props.className} form-select`}>
        {props.label && <label>{props.label}</label>}
        <div className="select-wrapper">
          <SelectField
            className="select-field"
            options={props.options}
            name={input.name}
            value={value || input.value}
            disabled={input.disabled}
            onChange={handleChange}
            iconStyle={{
              fill: 'none',
            }}
          >
            {props.hasPrimaryText && (
              <MenuItem primaryText={props.primaryText} value={null} />
            )}
            {options.map((option, idx) => (
              <MenuItem
                key={idx}
                primaryText={option.label}
                value={option.value}
                disabled={option.disabled}
                leftIcon={option.icon}
              />
            ))}
          </SelectField>
          <ArrowIcon />
        </div>
      </div>
      {renderError(props, error)}
    </div>
  )
}

/**
 * Render field error
 * @returns JSX.Element | null
 */
function renderError(props, error) {
  const { meta = {}, error: propsError } = props
  const inputError = (meta.touched && meta.error) || propsError || error

  return inputError ? (
    <MessageErrorInput key="errorMessage" message={inputError} />
  ) : null
}

const getSelectOptions = ({ options, sorted, ASC }) => {
  if (sorted) {
    return globalSort({
      data: options,
      sortingKey: 'label',
      ASC,
    })
  } else {
    return options
  }
}



// WEBPACK FOOTER //
// ./src/Components/Form/SelectDashboard/unstyled.js